import { useState, useEffect } from "react";
import * as Icons from "lucide-react";

import { scrollToSection } from "@/lib/scroll";

const WhatsAppIcon = ({ className }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className}>
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
  </svg>
);

const BELL_SOUND = "data:audio/wav;base64,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";

const playBellSound = () => {
  try {
    const audio = new Audio(BELL_SOUND);
    audio.volume = 0.3;
    audio.play().catch(() => { });
  } catch { }
};

const StickyMobileCTA = ({ ctaData }) => {

  const [visible, setVisible] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);
  const [pulseEnquiry, setPulseEnquiry] = useState(false);

  useEffect(() => {
    // Slide up after short delay
    const showTimer = setTimeout(() => setVisible(true), 800);
    // Pulse enquiry + tooltip after 3s
    const pulseTimer = setTimeout(() => {
      setPulseEnquiry(true);
      setShowTooltip(true);
    }, 3000);
    // Stop pulse after 2s
    const stopPulse = setTimeout(() => setPulseEnquiry(false), 5000);
    // Hide tooltip after 3s
    const hideTooltip = setTimeout(() => setShowTooltip(false), 6000);

    return () => {
      clearTimeout(showTimer);
      clearTimeout(pulseTimer);
      clearTimeout(stopPulse);
      clearTimeout(hideTooltip);
    };
  }, []);

  const scrollTo = (id) => {
    scrollToSection(id);
  };

  const tabs = (ctaData?.tabs || []).map(tab => {
    const Icon = Icons[tab.icon] || Icons.Home;
    let action;
    if (tab.label === "Home") action = () => window.scrollTo({ top: 0, behavior: "smooth" });
    else if (tab.isEnquiry) action = () => { playBellSound(); scrollTo("enquiry"); };
    else if (tab.highlight) action = () => { playBellSound(); scrollTo("self-booking"); };
    else if (tab.label === "Call") action = () => { playBellSound(); window.location.href = tab.href || "tel:+919869929292"; };
    else if (tab.label === "WhatsApp") action = () => {
      const referenceText = `Reference: ${window.location.href}`;
      const message = encodeURIComponent(`Hi! I'd like to chat with a Puja Advisor about a ceremony.\n\n${referenceText}`);
      window.open(`https://wa.me/919869929292?text=${message}`, "_blank");
    };

    return {
      ...tab,
      icon: Icon,
      action
    };
  });

  return (
    <div
      className={`fixed bottom-0 left-0 right-0 z-50 md:hidden bg-gradient-to-r from-primary to-[hsl(355,78%,28%)] backdrop-blur-md border-t border-gold/30 safe-area-pb transition-transform duration-500 ease-out ${visible ? "translate-y-0" : "translate-y-full"
        }`}
    >
      <div className="flex items-end justify-around px-2 pt-1 pb-2">
        {tabs.map((tab) => (
          <button
            key={tab.label}
            onClick={tab.action}
            className="relative flex flex-col items-center gap-0.5 min-w-[52px] focus:outline-none"
          >
            {tab.highlight ? (
              <span className="relative flex items-center justify-center -mt-5">
                <span className="absolute w-14 h-14 rounded-full bg-gold/30 animate-glow-pulse" />
                <span className="relative flex items-center justify-center w-12 h-12 rounded-full bg-gradient-to-br from-primary to-[hsl(355,70%,25%)] text-gold shadow-lg border-2 border-gold/60">
                  <Icons.Zap className="h-5 w-5 text-pending-color" />
                </span>
              </span>
            ) : tab.customIcon ? (
              <WhatsAppIcon className="h-5 w-5 text-white/80" />
            ) : (
              <span className="relative inline-flex items-center justify-center">
                <tab.icon className={`h-5 w-5 text-white/80 ${tab.isEnquiry && pulseEnquiry ? "animate-attention-pulse" : ""}`} />
                {/* Gold notification dot for Enquiry */}
                {tab.isEnquiry && (
                  <span className="absolute -top-1 -right-1 w-2 h-2 rounded-full bg-gold" />
                )}
              </span>
            )}

            {/* Tooltip for Enquiry */}
            {tab.isEnquiry && showTooltip && (
              <span className="absolute -top-8 left-1/2 -translate-x-1/2 whitespace-nowrap bg-gold text-primary-foreground text-[10px] font-semibold px-2 py-0.5 rounded-md shadow-lg animate-fade-in">
                {tab.tooltip || "Need help?"}
                <span className="absolute top-full left-1/2 -translate-x-1/2 w-0 h-0 border-l-4 border-r-4 border-t-4 border-transparent border-t-gold" />
              </span>
            )}

            <span className={`text-[10px] font-medium ${tab.highlight ? "text-white" : "text-white/80"}`}>
              {tab.label}
            </span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default StickyMobileCTA;
